
// Step 1: Get total pages from anchor tag
const nextBtn = document.querySelector('.pagination-custom__next');
const totalPages = parseInt(nextBtn?.getAttribute('data-totalpages'), 10);

// Step 2: Generate nextPenSlugs array based on totalPages
const nextPenSlugs = [];

if (!isNaN(totalPages)) {
  for (let i = 2; i <= totalPages; i++) {
    nextPenSlugs.push(`page=${i}`);
  }
}

console.log(nextPenSlugs);


function getPenPath() {
  const currentParams = new URLSearchParams(window.location.search);
  const slug = nextPenSlugs[this.loadCount];

  if (slug) {
    const pageNumber = slug.split('=')[1]; // get just the number
    currentParams.set('page', pageNumber); // set or replace existing page param

    return window.location.pathname + '?' + currentParams.toString();
  }
}

// 👇 JSON string hata ke direct object use kiya
var isSettingsObj = {
  container: "#CollectionLoop",
  path: getPenPath,
  append: "#CollectionLoop .grid-item",
  hideNav: ".pagination-custom",
  status: ".page-load-status"
};

let infScroll;

function loadproducts() {
  var elem = document.querySelector(isSettingsObj.container);
  if (!elem) return;

  if (infScroll && infScroll.destroy) {
    infScroll.destroy();
  }

  infScroll = new InfiniteScroll(elem, {
    path: isSettingsObj.path,
    append: isSettingsObj.append,
    history: false,
    hideNav: isSettingsObj.hideNav,
    status: isSettingsObj.status
  });
}

loadproducts();

document.addEventListener('click', function (e) {
  if (e.target && e.target.parentElement && e.target.parentElement.parentElement) {
    var desktopFilter = e.target.classList.contains('collection-filters__sort') ||
      e.target.classList.contains('filter-value') ||
      e.target.classList.contains('facets-checkbox') ||
      e.target.classList.contains('popout-list__option') ||
      e.target.classList.contains('active-facets__button-inner');
    
      console.log(desktopFilter);
    var mobileFilter = e.target.classList.contains('select__select') ||
      e.target.classList.contains('mobile-facets__checkbox');

    var desktopFilterBtn = e.target.parentElement.classList.contains('underlined-link') &&
      e.target.parentElement.parentElement.classList.contains('active-facets__button-wrapper');

    var mobileFilterBtn = e.target.classList.contains('underlined-link') &&
      e.target.parentElement.classList.contains('mobile-facets__clear-wrapper');

    if (desktopFilter || mobileFilter || desktopFilterBtn || mobileFilterBtn) {
      setTimeout(function () {
        loadproducts();
      }, 5000); // 1s delay is enough
    }
  }
});
document.addEventListener('click', function (e) {
  const sortItem = e.target.closest('.popout-list__item');
  if (sortItem) {
          setTimeout(function () {
        loadproducts();
      }, 5000); // 1s delay is enough
  }
});
